import { onArtistRiderActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ArtistRiderActivityCard } from "./ArtistRiderActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  artistRiderId: number
  fileId: string
  config: server.dto.ActivityPanelConfig
}

export const ArtistRiderActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  const [fileId, setFileId] = React.useState<string>(props.fileId);

  return <ActivityPanel<server.dto.ArtistRiderActivity>
    activityKey="artistRider"
    itemId={props.artistRiderId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ArtistRider.ListActivity({ itemId: props.artistRiderId, page, perPage })}
    renderActivity={(activity => <ArtistRiderActivityCard
      currentFileId={fileId}
      setCurrentFileId={setFileId}
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onArtistRiderActivity}
    onActivity={(activity) => {
      if (activity.action.value === "uploadedNewFile") {
        setFileId(activity.fileId);
      }

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
